// Import the mixins
import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'

// Import firebase
import { propertiesModel, emailsModel, residentsModel } from '@/firebase/firebase-config'

// Import the events
import { CreateStripeCustomer } from '@/events/stripe/CreateStripeCustomer'

export const SendEnrollmentInviteEmail = {

    /*
	**  Register the mixins
	*/

	mixins: [

        BugsnagService,
        SpinnerMethods,
        CreateStripeCustomer

    ],

    /*
	**  Set up the data
	*/

	data: () => ({

        processing: false,
        email_sent: false,
        property_resident_updated: false,
        resident_updated: false,
        resident_id: null,
        property_id: null,
        to_email: null,
        first_name: null,
        referral_code: null,
        stripe_customer_props_set: false,
        enrollment_invite_error: false,
        stripe_customer_created: false

    }),

    /*
    **  Watch em'
    */

    watch: {

        stripe_customer_props_set: {

            immediate: true, // Step 2
            handler(stripe_customer_props_set) {

                /*
                **  Set the Stripe Customer
                **  @method: @Events/Stripe/CreateStripeCustomer
                */

                if (!this.enrollment_invite_error && stripe_customer_props_set) this.createStripeCustomerHandler();

            }

        },

        stripe_customer_created: {

            immediate: true, // Step 3
            handler(stripe_customer_created) {

                /*
                **  Send the email
                **  @method: @here
                */

                if (!this.enrollment_invite_error && stripe_customer_created) this.sendEnrollmentEmail();

            }

        },

        email_sent: {

            immediate: true, // Load on created
            handler(email_sent) {

                /*
                **  Update the property resident doc
                **  @method: @here
                */
               
                if (email_sent) this.updatePropertyResidentEnrollment();

            }

        },

        property_resident_updated: {

            immediate: true, // Load on created
            handler(property_resident_updated) {

                /*
                **  Update the resident doc
                **  @method: @here
                */
               
                if (property_resident_updated) this.updateResidentEnrollment();

            }

        },

        resident_updated: {

            immediate: true, // Load on created
            handler(resident_updated) {

                /*
                **  Complete the event
                **  @method: @here
                */
               
                if (resident_updated) this.completeTheEnrollmentEvent();

            }

        },

        enrollment_invite_error: {

            immediate: true, // Load on created
            handler(enrollment_invite_error) {

                /*
                **  Handle the error
                **  @method: @here
                */

                if (enrollment_invite_error) this.handleEnrollInviteError();

            }

        }

    },

    /*
	**  Methods
    */
    
    methods: {

        sendEnrollmentInviteEmailHandler: function(to_email, first_name, referral_code, resident_id, property_id) {

            try {

                /*
                **  If double clicked
                **  @prop: @here
                */

                if (this.processing) return;

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.processing = true;

                /* 
                **  Show the spinner
                **  @method: Mixins/Helpers/SpinnerMethods
                */

                this.showSpinner();

                /*
                **  Set the props to be referenced later
                **  @prop: @here
                */

                this.resident_id = resident_id;
                this.property_id = property_id;
                this.to_email = to_email;
                this.first_name = first_name;
                this.referral_code = referral_code;

                /*
                **  Update the property resident
                **  @method: @here
                */

                this.setStripeCustomerProps();

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.enrollment_invite_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Send the Invite Email from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Emails',
                    uid: 'PwjYBWq1QSxU8xleOTP2',
                    error: e
                });

            }

        },

        handleEnrollInviteError: function() {

            try {

                /*
                **  Set the processing prop
                **  @prop: @here
                */

                this.processing = false;
    
                /*
                **  Hide the spinner
                **  @method: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /*
                **  Throw error message
                **  @service: SweetAlert2
                */

                this.$swal('Uh Oh!', 'We ran into some problems while trying to send the invitation email.', 'error');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Handle an Error for sending and Enrollment Invite Email.',
                    errorType: 'Application',
                    section: 'Events/Emails',
                    uid: 'XNGIaW80ULRs5OK9JGcn',
                    error: e
                });

            }

        },

        setStripeCustomerProps: function() {

            try {

                /*
                **  Set the props
                **  @props: @Events/Stripe/CreateStripeCustomer
                */

                this.stripe_customer.first_name = this.resident.attributes.contact_information.first_name;
                this.stripe_customer.last_name = this.resident.attributes.contact_information.last_name;
                this.stripe_customer.street_1 = this.property.attributes.address.street_1;
                this.stripe_customer.phone_number = this.resident.attributes.contact_information.phone_number;
                this.stripe_customer.email = this.resident.attributes.contact_information.email;
                this.stripe_customer.resident_id = this.resident.id;
                this.stripe_customer.property_id = this.property.id;
                this.stripe_customer.company_id = this.resident.relationships.company;

                /*
                **  Set the complete prop
                **  @prop: @here
                */

                this.stripe_customer_props_set = true;

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.enrollment_invite_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */

                this.reportAuthBugsnagError({
                    title: 'Unable to Set the Stripe Customer Props.',
                    errorType: 'Application',
                    section: 'Events/Emails',
                    uid: 'WDjlb8hgHAE0Ge9gVR11',
                    error: e
                });

            }

        },

        sendEnrollmentEmail: function() {

            try {

                /*
                **  Send the email
                **  @service: @Firebase/Firestore
                */

                emailsModel.add({
					to: this.to_email,
					template: {
						name: 'ResidentWelcomeEmail',
						data: {
							first_name: this.first_name,
							referral_code: this.referral_code,
							url: process.env.VUE_APP_RESIDENTS_URL + 'sign-up' + '?ref=' + this.referral_code
						}
					}
				})
                .then(() => {

                    /*
                    **  Update the prop
                    **  @prop: @here
                    */
                   
                    this.email_sent = true;

                })
				.catch(error => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.enrollment_invite_error = true;

   					/*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */

					this.reportAuthBugsnagError({
						title: 'Send Resident Welcome Email',
						errorType: 'Firestore Database',
						section: 'Events/Emails',
                        uid: 'mOWx5SdwOyJ3ibE5BXK9',
						error: error
					});

   				});

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.enrollment_invite_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to Send the Invite Email from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Emails',
                    uid: 'x85yignSJTQ3EcNpKnBN',
                    error: e
                });

            }

        },

        updatePropertyResidentEnrollment: function() {

            try {

                /*
                **  Get the events
                **  @service: @Firebase/Firestore
                */

                propertiesModel.doc(this.property_id).collection('residents').doc(this.resident_id).update({
                    'attributes.site_enrollment.send_email': true,
                    'attributes.site_enrollment.enroll_resident': true,
                    'attributes.site_enrollment.enrollment_date': moment().unix(),
                    'meta.updated_at': moment().unix()
                })
                .then(() => {

                    /*
                    **  Update the prop
                    **  @prop: @here
                    */
                   
                    this.property_resident_updated = true;
                    
                })
                .catch(error => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.enrollment_invite_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Update Property Resident\'s Portal Enrollment from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Emails',
                        uid: 'QnZNlTUwKEPc0EDaerLV',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Set the prop
                **  @prop: @here
                */

                this.enrollment_invite_error = true;

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Update Property Resident\'s Resident Portal Enrollment from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Emails',
                    uid: 'QnZNlTUwKEPc0EDaerLV',
                    error: e
                });

            }

        },

        updateResidentEnrollment: function() {

            try {

                /*
                **  Get the events
                **  @service: @Firebase/Firestore
                */

                residentsModel.doc(this.resident_id).update({
                    'attributes.site_enrollment.send_email': true,
                    'attributes.site_enrollment.enroll_resident': true,
                    'attributes.site_enrollment.enrollment_date': moment().unix(),
                    'meta.updated_at': moment().unix()
                })
                .then(() => {

                    /*
                    **  Update the prop
                    **  @prop: @here
                    */
                   
                    this.resident_updated = true;
                    
                })
                .catch(error => {

                    /*
                    **  Set the prop
                    **  @prop: @here
                    */

                    this.enrollment_invite_error = true;

                    /*
                    **  Send to Bugsnag
                    **  @service: Bugsnag/BugsnagService
                    */
                
                    this.reportAuthBugsnagError({
                        title: 'Update Resident\'s Portal Enrollment from Firestore',
                        errorType: 'Firestore Database',
                        section: 'Events/Emails',
                        uid: '3jDXSOoguvhIj6LHHQXV',
                        error: error
                    });

                });

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Update Resident\'s Resident Portal Enrollment from Firestore',
                    errorType: 'Firestore Database',
                    section: 'Events/Emails',
                    uid: 'bNxw3XBmgIHVycZrsUTj',
                    error: e
                });

            }

        },

        completeTheEnrollmentEvent: function() {

            try {

                /* 
                **  Hide the spinner
                **  @method: Mixins/Helpers/SpinnerMethods
                */

                this.hideSpinner();

                /* 
                **  Reset the props
                **  @props: @here
                */

                this.processing = false;
                this.email_sent = false;
                this.property_resident_updated = false;
                this.resident_updated = false;
                this.resident_id = null;

                /* 
                **  Throw success message
                **  @service: @SweetAlert2
                */

                this.$swal('Success!', 'Your resident portal invitation has been sent.', 'success');

            } catch (e) {

                /*
                **  Send to Bugsnag
                **  @service: Bugsnag/BugsnagService
                */
            
                this.reportAuthBugsnagError({
                    title: 'Unable to complete the event when inviting a resident to the portal.',
                    errorType: 'Firestore Database',
                    section: 'Events/Emails',
                    uid: '1l2LuLYGnZXMemDLBryB',
                    error: e
                });

            }

        }

    }

}